import { render, staticRenderFns } from "./beneficio-container.vue?vue&type=template&id=67ed8b93&"
import script from "./beneficio-container.vue?vue&type=script&lang=ts&"
export * from "./beneficio-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ed8b93')) {
      api.createRecord('67ed8b93', component.options)
    } else {
      api.reload('67ed8b93', component.options)
    }
    module.hot.accept("./beneficio-container.vue?vue&type=template&id=67ed8b93&", function () {
      api.rerender('67ed8b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/beneficio/beneficio-container.vue"
export default component.exports